import _Message from "@arco-design/web-react/es/Message";
import _Modal from "@arco-design/web-react/es/Modal";
import _useEventBus from "@byted/hooks/es/useEventBus";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState } from 'react';
import { UpdateTheme } from '@api/theme';
import ThemeForm from '../themeCreate/themeForm';
import useLocale from '@src/hooks/useLocale';
import { isExternalProd } from '@src/utils/env';
import { quickUpdateSpaceRoleMember } from '@src/utils/api/space';
import { themeOperate } from '@src/utils/constants';
var EditTheme = function EditTheme(props) {
  var theme = props.theme,
    readonly = props.readonly,
    onOk = props.onOk,
    rest = __rest(props, ["theme", "readonly", "onOk"]);
  var _a = __read(useState(props.defaultVisible), 2),
    visible = _a[0],
    setVisible = _a[1];
  var t = useLocale().t;
  _useEventBus('openEdit', function () {
    setVisible(true);
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      setVisible(true);
    }
  }, props.children), visible ? /*#__PURE__*/React.createElement(_Modal, __assign({
    visible: true,
    style: {
      width: 531
    },
    footer: null,
    title: t['themeEdit.drawer.title']
  }, rest, {
    onCancel: function onCancel() {
      setVisible(false);
    }
  }), /*#__PURE__*/React.createElement(ThemeForm, {
    disabled: readonly,
    onCancel: function onCancel() {
      setVisible(false);
    },
    initialValue: theme,
    operate: themeOperate.edit,
    onSubmit: function onSubmit(values) {
      return __awaiter(void 0, void 0, void 0, function () {
        var newTheme, belongSpace, owners, users, preBelongSpace;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4, UpdateTheme(__assign(__assign({}, values), {
                depVersion: values.depVersion || '',
                themeId: theme.themeId
              }))];
            case 1:
              newTheme = _a.sent();
              if (!!isExternalProd) return [3, 3];
              belongSpace = newTheme.belongSpace, owners = newTheme.owners;
              users = owners.map(function (owner) {
                return {
                  id: owner,
                  name: owner,
                  userType: 'person_account'
                };
              });
              preBelongSpace = theme.belongSpace || {};
              if (!!Object.keys(preBelongSpace).length) return [3, 3];
              return [4, quickUpdateSpaceRoleMember({
                spaceId: belongSpace.spaceId,
                groupId: belongSpace.groupId,
                isAdmin: true,
                users: users
              })];
            case 2:
              _a.sent();
              _a.label = 3;
            case 3:
              _Message.success(t['themeEdit.drawer.update.success']);
              setVisible(false);
              onOk === null || onOk === void 0 ? void 0 : onOk(newTheme);
              return [2];
          }
        });
      });
    }
  })) : null);
};
export default EditTheme;